/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import PropTypes from 'prop-types';
import React from 'react';
import Truncate from '@salesforce/design-system-react/components/utilities/truncate';
import mcLib from '../../../api/mc-lib';

function handleBlogClick() {
  mcLib.logEvent('Salesforce Blogs', 'Blog Post');
}

const decodeHTML = function (html) {
  const txt = window.document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

function BlogItem(props) {
  return (
    <li className="slds-item">
      <div className="slds-tile slds-media">
        <div className="slds-media__body">
          <h3>
            <a href={props.url} onClick={() => handleBlogClick()} target="_blank" rel="noopener noreferrer">
              {decodeHTML(props.title)}
            </a>
          </h3>
          <div className="slds-tile__detail slds-text-body--small">
            <Truncate
              line={3}
              suffix="...................."
              text={decodeHTML(props.body.replace(/<[^>]{0,11}>/g, ''))}
            />
          </div>
        </div>
      </div>
    </li>
  );
}

BlogItem.displayName = 'Salesforce Blog Item';

BlogItem.propTypes = {
  body: PropTypes.string.isRequired,
  dataURI: PropTypes.string,
  imageSize: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
};

BlogItem.defaultProps = {
  imageSize: '72px',
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default BlogItem;
